export const LOGIN = "login";
export const LOGOUT = "logout";
export const CHECK_AUTH = "checkAuth";



